import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ServiceJob } from "@/models/admin/serviceJob/serviceJob"
import { IServiceJob } from "@/models/admin/serviceJob/serviceJob.types"

// A trigger merged with its cron expression (if any). qrtz_triggers and
// qrtz_cron_triggers are separate, unrelated Hasura tables, so the cron value is
// joined onto the trigger in ServiceJobsService before parsing.
export type ServiceJobRaw = {
  sched_name: string
  cron_expression: string | null
}

export const ServiceJobParser: IParser<IServiceJob, ServiceJobRaw> = {
  toDomain(data) {
    try {
      return new ServiceJob(data.sched_name, data.cron_expression ?? null)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
